import { Box } from "@mui/material";
import MissionOneContainer from "pages/missionOne";
import { useMemo } from "react";
import { useLocalStorage } from "utils/localStorage";
import IMGBackground from "./assets/images/background.jpg";
import Greetings from "./components/Greetings";
import Name from "./components/Name";
import Password from "./components/Password";
import PersonalReport from "./components/PersonalReport";
import Questionnaire from "./components/Questionnaire";
import ResultCelebration from "./components/ResultCelebration";
import SignUp from "./components/SignUp";
import { RegistrationCtx, type QuestionnaireType } from "./contexts/RegistrationCtx";

const components = [
	Greetings,
	Name,
	Questionnaire,
	MissionOneContainer,
	// BiggestChallenges,
	PersonalReport,
	SignUp,
	Password,
	ResultCelebration
	// Result
];

function Registration()
{
	const [ name, setName ] = useLocalStorage<string>("registration-name", "");
	const [ email, setEmail ] = useLocalStorage<string>("registration-email", "");
	const [ step, setStep ] = useLocalStorage<number>("registration-step", 1);
	const [ before, setBefore ] = useLocalStorage<QuestionnaireType>("registration-questionnaire", {
		clarity: 0,
		confidence: 0,
		selfKnowledge: 0,
		anxiety: 0
	});

	const context = useMemo(() =>
	{
		return {
			setStep,
			name,
			setName,
			email,
			setEmail,
			before,
			setBefore
		};
	}, [ name, email ]);

	const Component = useMemo(() =>
	{
		if ((step - 1) === components.length)
		{
			return () => (<h1 style={{ margin: "auto" }}>Step not found? (Step: {step})</h1>);
		}

		return components?.[ step - 1 ];
	}, [ step ]);

	// Render
	return (
		<RegistrationCtx.Provider value={context}>
			<Box sx={{
				minHeight: "100vh",
				background: `url(${ IMGBackground }) center center/cover`,
				display: "flex",
				flexDirection: "column",

				"@supports (min-height: 100dvh)":
				{
					minHeight: "100dvh"
				}
			}}>
				<Component />
			</Box>
		</RegistrationCtx.Provider>
	);
}

export default Registration;
